(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["news-events"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.yccij-news__more';

    function closeDetails(details, restoreFocus) {
      details.open = false;
      if (restoreFocus) details.querySelector('summary').focus({ preventScroll: true });
    }

    function positionDetails(details) {
      const panel = details.querySelector('.yccij-news__more-content');
      const summary = details.querySelector('summary').getBoundingClientRect();
      const headerBottom = document.getElementById('SiteHeader')?.getBoundingClientRect().bottom || 0;
      const below = window.innerHeight - summary.bottom - 22;
      const above = summary.top - Math.max(12, headerBottom + 12) - 10;
      const placeAbove = below < Math.min(panel.scrollHeight, 420) && above > below;

      details.dataset.placement = placeAbove ? 'above' : 'below';
      panel.style.maxHeight = Math.max(80, Math.min(420, placeAbove ? above : below)) + 'px';
    }

    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!details.matches(selector) || !details.open) return;

      document.querySelectorAll(selector + '[open]').forEach((other) => {
        if (other !== details) closeDetails(other, false);
      });
      positionDetails(details);
    }, true);

    document.addEventListener('click', (event) => {
      document.querySelectorAll(selector + '[open]').forEach((details) => {
        if (event.target.closest('.yccij-news__more-close')) {
          closeDetails(details, true);
        } else if (!details.contains(event.target)) {
          closeDetails(details, false);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(selector + '[open]').forEach((details) => {
        closeDetails(details, true);
      });
    });

    window.addEventListener('resize', () => {
      document.querySelectorAll(selector + '[open]').forEach(positionDetails);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["past-exhibitions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const picture = event.target.closest('.yccij-archive__picture');
    if (picture) {
      picture.setAttribute('aria-pressed', String(picture.getAttribute('aria-pressed') !== 'true'));
    }
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    const entry = event.target.closest('.yccij-archive__entry');
    if (!entry || entry.contains(event.relatedTarget)) return;
    const picture = entry.querySelector('.yccij-archive__picture');
    if (picture) picture.setAttribute('aria-pressed', 'false');
  });

  document.addEventListener('shopify:block:select', (event) => {
    const earlier = event.target.closest('.yccij-archive__earlier');
    if (earlier) earlier.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
